import { c as _c } from "react-compiler-runtime";
import { useMemo } from 'react';
import { TABS } from '../constants/tabs';
const parentRenderedFeatures = [TABS.APPROVALS];
export function useIsTabParentRendered(tab) {
  "use memo";

  const $ = _c(2);
  let t0;
  if ($[0] !== tab) {
    t0 = parentRenderedFeatures.includes(tab);
    $[0] = tab;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}